
import { Button } from "~/components/ui/button";

type DeclarationSuccessProps = {
  alreadyCompleted?: boolean;
};

export default function DeclarationSuccess({ alreadyCompleted = false }: DeclarationSuccessProps) {

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-primary mb-4">
          {alreadyCompleted ? "Declaration Already Completed" : "Declaration Submitted!"}
        </h2>
        <p className="mb-6">
          {alreadyCompleted
            ? "You have already completed your declaration for this application."
            : "Thank you for completing your declaration. You may now close this page."}
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => {
              window.close();
              // If window.close() was blocked by the browser, redirect to home
              window.location.href = "https://proudlyhuman.org";
            }}
            className="w-full"
          >
            Close Page
          </Button>
        </div>
      </div>
    </div>
  );
}

